module.exports = __webpack_public_path__ + "static/langojango-arabic-language-phrasebook-96889bbc4ed6f6210efa97e2d70e1ad8.png";